'use client';
import { useAuth } from '@clerk/nextjs';
import { useViewerPlan as useSharedViewerPlan } from '@marine/services';

/** The signed-in viewer's plan — see the shared `useViewerPlan`. */
export const useViewerPlan = () => {
  const { userId } = useAuth();

  return useSharedViewerPlan(userId);
};
